export default {
    DISCONNECTED: 0,
    PAIRED: 1,
    CONNECTED: 2,
    READY: 3,
    WRONG_DEVICE: 4,
    NOT_SUPPORTED: 5,
};
